(() => {
  const init = () => {
    document.querySelectorAll('[data-card-slides]').forEach((slides) => {
      const card = slides.closest('[data-collection-card]');
      if (!card) return;
      const step = () => slides.clientWidth;
      card.querySelector('[data-card-prev]')?.addEventListener('click', () => slides.scrollBy({ left: -step(), behavior: 'smooth' }));
      card.querySelector('[data-card-next]')?.addEventListener('click', () => slides.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
